"use strict"

const request = require("request-promise-native")
const hmacSignature = require('hmac-signature')
const _ = require('lodash')

//TODO decouple request out of it to let caller use whatever http client they like

class Voco {
    constructor(config) {
        this.config = config

        if (typeof this.config.domainParts == "string") {
            this.config.domainParts = this.config.domainParts.split("-")
        }

        const services = _.mapValues(config.services, this.makeService.bind(this))
        _.merge(this, services)
    }

    makeService(options, name) {
        const domainParts = this.config.domainParts.concat(options.domainPart ? [options.domainPart]:[])
        const protocol = options.insecure ? "http" : "https"
        const port = options.port
        const defaults = {
            baseUrl: (options.baseUrl ? options.baseUrl : (`${protocol}://` + (domainParts.length > 0? (domainParts.join('-') + ".") : "") + this.config.domain)) + (port ? (":" + port) : ""),
            resolveWithFullResponse: true
        }

        if(options.defaults){
            _.merge(defaults, options.defaults)
        }

        switch(name) {
            case 'api':
            case 'gtp':
            default:
                defaults.baseUrl += '/_/' + name
                return new Service(defaults, options.secret)
        }

    }
}

class Service {
    constructor (defaults, hmacSecret) {
        this.request = request.defaults(defaults)
        this.defaults = defaults
        this.signDefaults = {
                version: 1,
                key: hmacSecret
            }
    }

    *sign (opts, obj) {
        const options = _.merge({}, this.signDefaults, opts)
        return yield hmacSignature.sign(options, obj)
    }
    
    url (url) {
       return this.defaults.baseUrl + "/" + (url || "")
    }

    post (url, obj, opts) {
        let options = _.merge({}, this.signDefaults, opts)
        let that = this

        return hmacSignature.sign(options, obj)
            .then(function (sig) {
                let requestOpts = {
                    url : url,
                    json : obj,
                    qs : { hmacSig : JSON.stringify(sig) }
                }

                return that.request.post(requestOpts)
            })
            .then(function (result) {
                if (result.statusCode != 200) {
                    throw new Error(result.body || result.statusMessage)
                }

                return result.body
            })
    }

    get (url, query, opts){
        let options = _.merge({}, this.signDefaults, opts)
        let that = this

        return hmacSignature.sign(options, query || {})
            .then(function (sig) {
                let qs = _.merge(query, ((that.defaults || {}).baseUrl || "").match(/_\/api/) ? { sig : JSON.stringify(sig) } : { hmacSig : JSON.stringify(sig) } )

                let requestOpts = {
                    url : url,
                    json : true,
                    qs : qs
                }

                return that.request.get(requestOpts)
            })
            .then(function (result) {
                if (result.statusCode != 200) {
                    throw new Error(result.body || result.statusMessage)
                }

                return result.body
            })
    }
}

module.exports = Voco
